import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import SectionTitle from "@/components/feature/SectionTitle";
import { getCategoryName, sortByHeat } from "@/utils/articles";

export default function HotRanking() {
  const ranked = sortByHeat(articles).slice(0, 8);
  const maxHeat = ranked[0]?.heat ?? 1;

  return (
    <section className="bg-background-100" aria-labelledby="hot-ranking-title">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionTitle
          eyebrow="实时更新"
          title={<span id="hot-ranking-title">今日热度榜</span>}
          description="按全网讨论量排序，每小时刷新一次。点开任意条目即可查看完整时间线与后续进展。"
          action={
            <Link
              to="/materials"
              className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
            >
              查看全部合集
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        <ol className="grid grid-cols-1 gap-x-10 gap-y-5 md:grid-cols-2">
          {ranked.map((item, index) => (
            <li key={item.id}>
              <div className="flex items-start gap-4 border-b border-background-200 pb-5">
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                    index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                      {getCategoryName(item.categoryId)}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
                    <Link to={`/material/${item.slug}`} className="transition-colors hover:text-primary-600">
                      {item.title}
                    </Link>
                  </h3>
                  <div className="mt-3 flex items-center gap-3">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                        style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                      />
                    </div>
                    <span className="whitespace-nowrap font-heading text-xs font-semibold text-foreground-700">
                      {item.heat.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}